module.exports = __webpack_public_path__ + "img/palani-ecru.4ee1895.webp";